import React from "react";
import "../../Styles/certified/tychon.css";

export default function Finzly() {
  return (
    <>
      <div className="tychon-certified-details-section">
        <div className="tychon-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="tychon-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="tychon-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="tychon-certified-badge"
            />
            <div className="tychon-certified-company-names">
              <a href="https://tychons.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/tychon/ty.png"
                alt="Walkzero Logo"
                className="tychon-certified-company-logo"
              />
            </a>
              <h1 className="tychon-certified-full-name">
              Tychon Solutions Pvt. Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="tychon-certified-details-right">
            <img
              src="/assets/tychon/tychon_2.jpg"
              alt="Finzly Office"
              className="tychon-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="tychon-certified-description">
          <h2>
            Why   Tychon Solutions Pvt. Ltd is an Outstanding Workplaces
          </h2>
          <p>
           Tychons is a global digital transformation partner delivering end-to-end technology solutions that help businesses scale and innovate. Their core offerings include:


          </p>
          <p>
            Digital Commerce solutions, covering development and integration across platforms like Adobe Commerce Adobe Commerce (Magento), Shopify, Shopify Plus, WooCommerce, and Salesforce Commerce Cloud, ensuring a solution that fits business needs.
          </p>
          <p>
          WMS & TMS solutions to optimize warehouse operations, inventory, and logistics
AI-powered solutions and analytics, including machine learning, predictive insights, and chatbots

          </p>
          <p>
            Custom development of tailored applications, APIs, and business integrations
Cloud infrastructure & hosting for secure, scalable, and high-performance environments
Automation & A/B testing to streamline workflows and continuously enhance user experiences
Together, these capabilities position Tychons as a comprehensive partner for driving digital growth and operational excellence.
          </p>
          
        </div>
        
        <div className="tychon-certified-info-cards">
          <div className="tychon-certified-info-card">
            <div className="tychon-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">100 Employees</div>
          </div>
          <div className="tychon-certified-info-card">
            <div className="tychon-certified-info-title">INDUSTRY</div>
            <div className="tychon-certified-info-value">Services

</div>
          </div>
          <div className="tychon-certified-info-card">
            <div className="tychon-certified-info-title">CONNECT</div>
            <div className="tychon-certified-info-icons">
              <span className="tychon-certified-icon-round">
                <a href="https://tychons.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="tychon-certified-icon-round">
                <a href="https://www.linkedin.com/company/tychon" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="tychon-certified-icon-round">
                <a href="https://www.facebook.com/profile.php?id=100057359174094#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="tychon-certified-info-card">
            <div className="tychon-certified-info-title">LOCATION (HQ)</div>
            <div className="tychon-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="tychon-certified-recognition-section">
          <h2 className="tychon-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="tychon-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="tychon-certified-recognition-image"
            />
          </div>
          <div className="tychon-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="tychon-certified-life-section">
          <h2 className="tychon-certified-life-title">
            Life at   Tychon Solutions Pvt. Ltd
          </h2>
          <div className="tychon-certified-life-gallery">
            <div className="tychon-certified-life-col">
              <img src="/assets/tychon/tychon_1.JPG" alt="Office 1" className="tychon-certified-life-img" />
              <img src="/assets/tychon/tychon_3.jpg" alt="Team 1" className="tychon-certified-life-img" />
            </div>
            <div className="tychon-certified-life-col tychon-certified-life-center">
              <img src="/assets/tychon/tychon_5.jpeg" alt="Main Office" className="tychon-certified-life-img tychon-certified-life-img-large" />
            </div>
            <div className="tychon-certified-life-col">
              <img src="/assets/tychon/tychon_6.jpeg" alt="Office 2" className="tychon-certified-life-img" />
              <img src="/assets/tychon/tychon_4.jpg" alt="Team 2" className="tychon-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
